import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import OrderTab from "./Tabs/OrderTab";
import WorkflowTab from "./Tabs/WorkflowTab";
import TrackingTab from "./Tabs/TrackingTab";
import DocumentTab from "./Tabs/DocumentTab";
import ChatTab from "./Tabs/ChatTab";

const OrderDashboard = (props) => {
  const [step, setStep] = useState(1);
  return (
    <div className="sm:mx-6 lg:mx-8">
      <div className={`sm:block sm:pt-1`}>
        <ul
          className="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9] space-x-12"
          id="tabs-tabJustify"
          role="tablist"
        >
          <li className="text-left cursor-pointer">
            <div
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 ${
                step === 1 &&
                "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setStep(1)}
            >
              Order Details
            </div>
          </li>
          <li className="text-left cursor-pointer">
            <div
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2  ${
                step === 2 &&
                "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setStep(2)}
            >
              Workflows
            </div>
          </li>
          <li className="text-left cursor-pointer">
            <div
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 ${
                step === 3 &&
                "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setStep(3)}
            >
              Tracking
            </div>
          </li>
          <li className="text-left cursor-pointer">
            <div
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 ${
                step === 4 &&
                "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setStep(4)}
            >
              Documents
            </div>
          </li>
          <li className="text-left cursor-pointer">
            <div
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 ${
                step === 5 &&
                "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setStep(5)}
            >
              Chat
            </div>
          </li>
        </ul>
      </div>

      {/* Tab Components */}

      {step === 1 && <OrderTab step={step} setStep={setStep} />}
      {step === 2 && <WorkflowTab step={step} setStep={setStep} />}
      {step === 3 && <TrackingTab step={step} setStep={setStep} />}
      {step === 4 && <DocumentTab step={step} setStep={setStep} />}
      {step === 5 && <ChatTab step={step} setStep={setStep} />}
    </div>
  );
};

OrderDashboard.auth = { path: "/order-dashboard", role: "ALL" };

export default OrderDashboard;
